export enum eAreaType {
  commercial = 'Comercial',
  basic = 'Básica',
  preBasic = "Pré-Básica",
  all = 'Todos'
}

export enum eAreaTypeNumber {
  commercial = '1',
  basic = '2',
  preBasic = "3",
  all = '4'
}
